module.exports = __webpack_public_path__ + "media/images/my_apps/feature_icons/icon_chromosomes_dna-24a47d8f74602a99263d8674fc0932a2.png";